<template>
    <div class="custom-control custom-radio">
        <input
            @change="updateInput"
            :checked="modelValue == value"
            :id="'radio-' + reference.id"
            :name="radioName"
            type="radio"
            class="custom-control-input"
        >
        <label class="custom-control-label" :for="'radio-' + reference.id">
            <span v-if="reference.recommended_cure" class="cure">Cure recomandée</span>
            {{ reference.name }}
            <span>
                <em class="promo" v-if="reference.discounted_price > 0">{{ reference.advantage_name }}</em>
                <del v-if="reference.discounted_price > 0">{{ reference.price | moneyFormat }}</del>
                {{ (reference.discounted_price > 0 ? reference.discounted_price : reference.price ) | moneyFormat }}
            </span>
        </label>
    </div>
</template>

<script>
    import {mapActions, mapState} from 'vuex';
    import store from '../store';

    const ProductReferenceCard = {
        name: 'ponroy-product-reference-card',
        store,
        model: {
            prop: 'modelValue'
        },
        props: {
            reference: {
                type: Object,
                required: true,
            },
            radioName: {
                type: String,
                required: true
            },
            value: {
                type: String,
            },
            modelValue: {
                type: String,
            },
        },
        methods: {
            updateInput() {
                this.$emit('input', this.value)
            }
        }
    };

    export default ProductReferenceCard;
</script>



// WEBPACK FOOTER //
// src/SiteBundle/Resources/assets/components/ProductReferenceCard.vue